(function webpackUniversalModuleDefinition(root, factory) {
	//Test Comment
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	//Test Comment
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	//Test Comment
	else if(typeof exports === 'object')
		exports["SavedItemsCompoent"] = factory();
	//Test Comment
	else
		root["SavedItemsCompoent"] = factory();
})(window, function() {
return 